export default {
  'environment': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'environment-osm': {
    type: 'vector',
    tiles: ['pmtiles://osm-data/{z}/{x}/{y}'],
    minzoom: 8,
    maxzoom: 14,
  },
  'breeding-sites': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'traps': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
    cluster: true,
    maxzoom: 23,
    clusterMaxZoom: 22,
    clusterRadius: 50,
    clusterProperties: {
      hasActive: ['any', ['==', ['get', 'status'], 'active']],
    },
  },
  'planner-traps': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'trap-connections': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'hovered-trap': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'mosquito-observations': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'lab-results': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
    cluster: true,
    clusterMaxZoom: 13,
    clusterRadius: 45,
    clusterProperties: {
      positiveCount: ['+', ['get', 'positiveCount']],
      negativeCount: ['+', ['get', 'negativeCount']],
    },
  },
  'hovered-lab-results': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'hovered-mosquito-observations': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'alerts': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'hovered-alert': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'new-alert': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'trap-buffers': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
  'grid': {
    type: 'geojson',
    data: { type: 'FeatureCollection', features: [] },
  },
}
